module.exports = __webpack_public_path__ + "img/reaction.fc67080c.svg";